import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

const QuickActionDialogs = ({
  quickActionType,
  quickActionReferenceId,
  quickActionDate,
  onReferenceIdChange,
  onDateChange,
  onClose,
  onSubmitPopcorn,
  onSubmitSetDates,
}) => (
  <>
    <Dialog open={quickActionType === 'popcorn'} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Force Popcorn Parent Live</DialogTitle>
      <DialogContent dividers sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <TextField
          label="Reference ID"
          value={quickActionReferenceId}
          onChange={(event) => onReferenceIdChange(event.target.value)}
          fullWidth
          size="small"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={onSubmitPopcorn} disabled={!quickActionReferenceId.trim()}>
          Submit
        </Button>
      </DialogActions>
    </Dialog>

    <Dialog open={quickActionType === 'setDates'} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Set Dates</DialogTitle>
      <DialogContent dividers>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            label="Billing / Selection / Effective"
            value={quickActionDate}
            format="MM/DD/YY"
            onChange={(value) => onDateChange(value)}
            slotProps={{ actionBar: { actions: ['today'] }, textField: { fullWidth: true, size: 'small' } }}
          />
        </LocalizationProvider>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          variant="contained"
          onClick={onSubmitSetDates}
          disabled={!quickActionDate || !quickActionDate.isValid || !quickActionDate.isValid()}
        >
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  </>
);

export default QuickActionDialogs;
